module.exports = __webpack_public_path__ + "static/img/flowers.dd4899b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flowers.gif
// module id = c/Zb
// module chunks = 1